import { Component, OnInit } from '@angular/core';
import { Model } from '../../../services/atbHome.service';

@Component({
  selector: 'app-hoteliers-payment',
  templateUrl: './hoteliers-payment.component.html',
  styleUrls: ['../../../app.component.css']
})
export class HoteliersPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-payment/hoteliers-payment.component.ts